import type { Member } from './types';
import type { CoverStore } from './gymCover';
import { gymCommentsKey, type GymComment } from './gymComments';
import { demoMemberMedia } from './demoMedia';

const reactions = [
  'The clear walkway beside the rack is such a good use of the space. Saving this idea for my next rearrange.',
  'That plate storage is tidy. Having everything within reach makes early sessions so much easier.',
  'Great balance of lifting space and room to warm up. How are you liking the flooring so far?',
  'The light in here is excellent. This looks like a space you would want to train in every day.',
  'Love seeing a garage built around the way you actually train. The bench corner is my favorite part.',
];

/** Populate browser storage once; never calls Supabase or creates an Auth identity. */
export function ensureDemoGymComments(
  members: Member[],
  store: CoverStore = localStorage,
  now = Date.now(),
) {
  const demoMembers = members.filter((member) => demoMemberMedia(member.id));
  for (const [gymIndex, gym] of demoMembers.entries()) {
    const key = gymCommentsKey(gym.id);
    const initialized = `${key}.initialized`;
    if (store.getItem(key) !== null) {
      store.setItem(initialized, '1');
      continue;
    }
    if (store.getItem(initialized) === '1') continue;
    const visitors = demoMembers.filter((member) => member.id !== gym.id);
    const comments: GymComment[] = visitors.map((member, index) => ({
      id: `d7200000-0000-4000-8000-${String(gymIndex * 10 + index + 1).padStart(12, '0')}`,
      gymOwnerId: gym.id,
      userId: member.id,
      displayName: member.display_name,
      username: member.username,
      avatarColor: member.avatar_color,
      body: reactions[(gymIndex + index) % reactions.length],
      createdAt: new Date(now - (25 - gymIndex * 3 - index) * 3_600_000).toISOString(),
    }));
    if (comments[0] && visitors[1]) {
      const member = visitors[1];
      comments.push({
        id: `d7300000-0000-4000-8000-${String(gymIndex + 1).padStart(12, '0')}`,
        gymOwnerId: gym.id,
        userId: member.id,
        displayName: member.display_name,
        username: member.username,
        avatarColor: member.avatar_color,
        body: 'Agreed! I moved my storage closer to the rack last weekend and it made a surprising difference.',
        createdAt: new Date(now - gymIndex * 3_600_000 - 30 * 60_000).toISOString(),
      });
    }
    store.setItem(key, JSON.stringify(comments));
    store.setItem(initialized, '1');
  }
}
